var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberOfPackagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 17,
    viewBox: "0 0 38 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7095 0H0V16.7135H17.7095V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4531 0H6.24863V6.66328H11.4531V0Z",
    fill: "#4083BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0489 0H19.3394V16.7135H37.0489V0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7925 0H25.588V6.66328H30.7925V0Z",
    fill: "#4083BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberOfPackagesIcon);
export default __webpack_public_path__ + "static/media/numberOfPackagesIcon.e7cb516201b7124028b3530211f00243.svg";
export { ForwardRef as ReactComponent };